import { useNavigate, useLocation } from 'react-router-dom';

export function useSwitchHousehold() {
  const navigate = useNavigate();
  const location = useLocation();

  return function switchHousehold(newHouseholdId) {
    if (location.pathname.startsWith('/h/')) {
      const parts = location.pathname.split('/');
      parts[2] = newHouseholdId;

      // Remove any additional path parts that might include identifiers of particular entities
      parts.splice(4);
      
      navigate(parts.join('/'));
    } else {
      navigate(`/h/${newHouseholdId}`);
    }
  };
}
